function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m30.093 36.9582v-10.395l-9.0712 5.2373-2.4135 9.0074-3.6304-.9701 2.1272-7.9387-7.9362-2.1267.9701-3.6303 9.0097 2.4143 9.1185-5.2645-9.1185-5.2645-9.0098 2.414-.9701-3.6304 7.9363-2.1263-2.1272-7.9392 3.6304-.9701 2.4135 9.0077 9.0714 5.2374v-10.3112l-6.704-6.7038 2.6602-2.6602 5.9175 5.9175 5.9608-5.9608 2.6602 2.6602-6.747 6.747v10.3647l9.1653-5.2914 2.4132-9.0054 3.6303.9701-2.1332 7.9606 7.9124 2.1201-.9701 3.6304-9.0096-2.4143-9.0898 5.2477 9.1197 5.2653 9.0078-2.4137.9701 3.6303-7.9583 2.1325 2.121 7.9151-3.6303.9701-2.4137-9.0077-9.1349-5.2739v10.4485l6.5955 6.5954-2.6602 2.6602-5.8092-5.809-5.8093 5.8088-2.6602-2.6602z",
  fill: "#015168",
  fillRule: "nonzero"
});

var SvgTalviretkeily = function SvgTalviretkeily(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "46.5666mm",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 63.5 46.5666",
    width: "63.5mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTalviretkeily, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/talviretkeily.40288b78.svg";
export { ForwardRef as ReactComponent };